import React from 'react'
import { useTranslation } from "react-i18next";
import { Modal, ModalTitle, ModalFooter } from "@vds/modals";
import { Text } from '@vds/core';
import { MarginSpacerL } from "common/components/styleTag";
import styled from 'styled-components';
import { Button } from "@vds/buttons";

const ModalDeviceContainer = styled.div`
`;
const ButtonGroup = styled.div`
display: flex;
margin-top: 25px;
margin-bottom: 2px;
column-gap: 10px;
height:44px;
span {
  margin-left:15px !important;
  margin-right:15px !important;
} 
@media screen and (max-width:830px) {
  position: absolute;
  bottom: 6rem;
  width: 95%;
  padding: 0px;
  margin-left: 0;
  flex-direction: column;
  row-gap: 12px;
  span {
    margin:0px !important;
  }
}
.customerButton{
  padding: 0 !important;
}
`;
const FooterWrapper = styled.div`
> div{
  padding-top: 2% !important;
}
> div > div > button > span{
  margin-left: 0 !important;
  margin-right: 0 !important;
}
`;

function EsimConfirmationModal({ handleActiveEsim, handleActivePsim, ...props }) {
  const { t } = useTranslation(["byod"]);
  return (
    <>
      <Modal
        hideCloseButton={true}
        disableOutsideClick={true}
        onOpenedChange={(e) => {
          if (!e) {
            handleActiveEsim()
          }
        }
        }
        opened={!!props.showModal}
        disableFocusLock= {true}
        
      >
        <ModalDeviceContainer>
          <ModalTitle>
              {t("byod.esim-confirmation-modal.header-text", { ns: "byod" })}
          </ModalTitle>
          <MarginSpacerL />

          <Text kind="body" className="helper-text" size="medium">
            <span> {t("byod.esim-confirmation-modal.confirmation-text", { ns: "byod" })}</span>
          </Text>
          <MarginSpacerL />
          <Text kind="body" className="helper-text" size="medium">
            <span> {t("byod.esim-confirmation-modal.confirmation-sub-text", { ns: "byod" })}</span>
          </Text>
          <FooterWrapper>
          <ModalFooter
            children={
              <ButtonGroup>
                <Button ClassName="customerButton"
                  width="100%"
                  use="primary"
                  onClick={() => handleActiveEsim()}
                >
                  {t("byod.esim-confirmation-modal.active-esim", { ns: "byod" })}
                </Button>
                <Button ClassName="customerButton"
                  width="100%"
                  use="secondary"
                  onClick={() => handleActivePsim()}
                >
                  {t("byod.esim-confirmation-modal.mail-psim", { ns: "byod" })}
                </Button>
              </ButtonGroup>
            }
          />
          </FooterWrapper>
        </ModalDeviceContainer>
      </Modal>

    </>
  );
}

export default EsimConfirmationModal;